import React from 'react';
import { Provider } from './Provider';
/**
 * Глобальная обертка над роутером
 */
export const Router = ({ children, router }) => (React.createElement(Provider, { router: router }, children));
